import React from "react";
import Banner from "./Banner";
import Footer from "./Footer";
import Questions from "./Questions";

const FAQ = () =>
{
    return(
        <>
        <Banner/>
        <Questions/>
        <Footer/>
        </>
    )
}

export default FAQ;